<template>
    <el-radio-group v-model="id" size="mini">
        <el-radio-button :label="item.id" v-for="item in list" :key="item.id">{{item.name}}</el-radio-button>
    </el-radio-group>
</template>

<script>
    export default {
        name: "hos-tab-toggle",
        props:{
            value:{
                type:Number,
                default:1
            },
            list:{
                type:Array,
                default: () => {
                    return []
                }
            }
        },
        data(){
            return {
                id:1
            }
        },
        watch:{
            id(newV){
                this.$emit('input', newV);
            }
        }
    }
</script>

<style scoped>

</style>